module.exports = __webpack_public_path__ + "static/media/wheel_spin.a04b61f3.ogg";